import React from 'react';

const CheckPerfil = (props) => {
    return (
        <div className="checkbox-container massivepermits-profiles">
            <input type="checkbox"
                checked={props.checked}
                value={props.id}
                key={props.key}
                data-value={props.id}
                id={props.codigo + props.id}
                onClick={props.checkItem} />
            <label htmlFor={props.codigo + props.id}>{props.codigo}</label>
        </div>
    );
}

export default CheckPerfil;